import { useEffect, useState } from "react";

import {
  FormControl,
  Box,
  Card,
  CardHeader,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import CommonDatePicker from "../../../Base/views/CommonDatePicker";
import "../../Css/dashboard.css";
import { useDispatch, useSelector } from "react-redux";
import not_checked_out from "../../Images/not_check_out.png";
import company_visitor from "../../Images/team.png";
import visitors from "../../Images/visitors.png";
import Chart from "react-apexcharts";
import Base from "../../../Base/views/Base";
import { GetVisitorsDataAction } from "../../../../../store/Employee/Visitors/Action";
import VisitorChartWithPagination from "./BarChartPagination";
import { ConvertDate } from "../../../Base/helper/baseFunctions";
import BackdropMeepl from "../../../Ancillary/AnimationComponents/BackdropMeepl";
const VisitorsDashboard = () => {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const { visitors_dashboard_data, visitorLoading } = useSelector(
    (state) => state?.EmployeeReducer?.VisitorsReducer
  );
  const { minDojYear } = useSelector(
    (state) => state?.AncillaryReducer?.WorkSpaceDojReducer
  );
  const date = new Date();

  const [filters, setFilters] = useState({
    from_date: `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`,
    to_date: `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`,
  });

  useEffect(() => {
    if (filters?.from_date && filters?.to_date) {
      dispatch(
        GetVisitorsDataAction({
          from_date: filters?.from_date,
          to_date: filters?.to_date,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);
  const handleFilter = (event, value) => {
    if (["from_date", "to_date"].includes(event?.target?.name)) {
      setFilters({ ...filters, [event?.target?.name]: event?.target?.value });
    }
  };

  const prepareChartData2 = (entryGateData) => {
    if (!entryGateData || Object.keys(entryGateData).length === 0) {
      return { dataSeries: [], categories: [] };
    }
    const categories = Object.keys(entryGateData); // Gate names as categories
    const allReasons = new Set();
    categories.forEach((gate) => {
      Object.keys(entryGateData[gate] || {}).forEach((reason) =>
        allReasons.add(reason)
      );
    });
    const dataSeries = Array.from(allReasons).map((reason) => ({
      name: reason,
      data: categories.map((gate) => entryGateData[gate][reason] || 0),
    }));
    return {
      categories,
      dataSeries,
    };
  };

  const prepareChartData = (visitorsData, datesPerPage, currentPage) => {
    if (!visitorsData || Object?.keys(visitorsData)?.length === 0) {
      return { series: [], dates: [] };
    }

    let dates = Object.keys(visitorsData);
    const reasons = [
      ...new Set(Object.values(visitorsData)?.flatMap((d) => Object.keys(d))),
    ];

    if (!reasons || reasons?.length === 0) {
      return { series: [], dates: [] };
    }

    const startIndex = (currentPage - 1) * datesPerPage;
    const endIndex = startIndex + datesPerPage;
    const paginatedDates = dates?.slice(startIndex, endIndex);

    const series = reasons?.map((reason) => ({
      name: reason,
      data: paginatedDates?.map((date) => visitorsData[date][reason] || 0),
    }));

    if (!series || series?.length === 0 || !dates || dates?.length === 0) {
      return { series: [], dates: [] };
    }
    return {
      series,
      paginatedDates,
      totalPages: Math.ceil(dates?.length / datesPerPage),
    };
  };

  const visitorsData =
    visitors_dashboard_data?.[0]?.reason_summary_by_date || {};

  const { series, paginatedDates, totalPages } = prepareChartData(
    visitorsData,
    7,
    currentPage
  );
  const entryGateData =
    visitors_dashboard_data?.[0]?.reason_region_summary || {};
  const { categories, dataSeries } = prepareChartData2(entryGateData);
  const entryGateDataLength = Object.keys(entryGateData)?.length;

  const chartData2 = {
    series: dataSeries,
    options: {
      chart: {
        type: "bar",
        stacked: true,
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false, 
        },
      },
      xaxis: {
        categories, 
        title: {
          text: "Entry Gates",
        },
      },
      yaxis: {
        title: {
          text: "Number of Visitors",
        },
      },
      colors: [
        "#4E79A7", // Blue
        "#E15759", // Red
        "#76B7B2", // Teal
        "#F28E2B", // Orange
        "#59A14F", // Green
        "#B07AA1", // Purple
        "#EDC948", // Yellow
        "#8C564B", // Brown
        "#17BECF", // Cyan
        "#FF9DA7", // Pink
        "#1F77B4", // Blue
        "#D62728", // Red
        "#9467BD", // Purple
        "#FF7F0E", // Orange
        "#2CA02C", // Green
        "#BCBD22", // Lime
        "#9C755F", // Tan
        "#BAB0AC", // Gray
        "#E377C2", // Magenta
        "#7F7F7F", // Neutral Gray
      ],
      legend: {
        position: "bottom",
        horizontalAlign: "center",
      },
      dataLabels: {
        enabled: false,
      },
      tooltip: {
        shared: true,
        intersect: false,
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          const total = series.reduce((sum, s) => sum + s[dataPointIndex], 0);
          const gateName = w.globals.labels[dataPointIndex]; 

          let tooltipContent = `<div style="padding: 5px 10px; font-size: 14px;">`;
          tooltipContent += `<strong>${gateName}</strong><br />`; 

          series.forEach((value, index) => {
            if (value[dataPointIndex] !== 0) {
              tooltipContent +=
                `<div style="padding: 2px 0; display: flex; align-items: center;">` +
                `<span style="display: inline-block; width: 12px; height: 12px; background-color: ${w.config.colors[index]}; border-radius: 50%; margin-right: 8px;"></span>` +
                `${w.globals.seriesNames[index]}: ${value[dataPointIndex]}` +
                `</div>`;
            }
          });

          tooltipContent += `<div style="padding: 3px 5px; border-top: 1px solid #ddd;">`;
          tooltipContent += `<strong>Total: ${total}</strong>`; 
          tooltipContent += `</div>`;
          tooltipContent += `</div>`;
          return tooltipContent;
        },
      },
      noData: {
        text: "No data available",
        align: "center",
        verticalAlign: "middle",
        offsetX: 0,
        offsetY: 0,
        style: {
          color: "#999999",
          fontSize: "16px",
          fontFamily: "Arial, sans-serif",
        },
      },
    },
  };
  const chartData = {
    series: series,
    options: {
      chart: {
        type: "bar",
        stacked: true,
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
        },
      },
      xaxis: {
        categories: paginatedDates,
        labels: {
          formatter: function (value) {
            const date = new Date(value);
            const day = date.getDate();
            const month = date.toLocaleString("default", { month: "short" });
            return `${day} ${month}`;
          },
        },
        title: {
          text: "Date",
        },
      },
      yaxis: {
        title: {
          text: "Number of Visitors",
        },
      },
      colors: [
        "#4E79A7", // Blue
        "#E15759", // Red
        "#76B7B2", // Teal
        "#F28E2B", // Orange
        "#59A14F", // Green
        "#B07AA1", // Purple
        "#EDC948", // Yellow
        "#8C564B", // Brown
        "#17BECF", // Cyan
        "#FF9DA7", // Pink
        "#1F77B4", // Blue
        "#D62728", // Red
        "#9467BD", // Purple
        "#FF7F0E", // Orange
        "#2CA02C", // Green
        "#BCBD22", // Lime
        "#9C755F", // Tan
        "#BAB0AC", // Gray
        "#E377C2", // Magenta
        "#7F7F7F", // Neutral Gray
      ],
      legend: {
        position: "bottom",
        horizontalAlign: "center",
      },
      dataLabels: {
        enabled: false,
      },
      tooltip: {
        shared: true,
        intersect: false,
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          const total = series.reduce((sum, s) => sum + s[dataPointIndex], 0);
          const date = new Date(w.globals.labels[dataPointIndex]);
          const day = date.getDate();
          const month = date.toLocaleString("default", { month: "short" });
          const formattedDate = `${day} ${month}`;

          let tooltipContent = `<div style="padding: 5px 10px; font-size: 14px;">`;
          tooltipContent += `<strong>${formattedDate}</strong><br />`; // Show the formatted date

          series.forEach((value, index) => {
            if (value[dataPointIndex] !== 0) {
              tooltipContent +=
                `<div style="padding: 2px 0; display: flex; align-items: center;">` +
                `<span style="display: inline-block; width: 12px; height: 12px; background-color: ${w.config.colors[index]}; border-radius: 50%; margin-right: 8px;"></span>` +
                `${w.globals.seriesNames[index]}: ${value[dataPointIndex]}` +
                `</div>`;
            }
          });

          tooltipContent += `<div style="padding: 3px 5px; border-top: 1px solid #ddd;">`;
          tooltipContent += `<strong>Total: ${total}</strong>`;
          tooltipContent += `</div>`;
          tooltipContent += `</div>`;
          return tooltipContent;
        },
      },
      noData: {
        text: "No data available",
        align: "center",
        verticalAlign: "middle",
        offsetX: 0,
        offsetY: 0,
        style: {
          color: "#999999", 
          fontSize: "16px", 
          fontFamily: "Arial, sans-serif", 
        },
      },
    },
  };

  const aggregatedData = Object.values(visitorsData)?.reduce((acc, current) => {
    for (const [reason, count] of Object.entries(current)) {
      acc[reason] = (acc[reason] || 0) + count;
    }
    return acc;
  }, {});

  const DchartData = Object.entries(aggregatedData)?.map(([reason, count]) => ({
    x: reason,
    y: count,
  }));

  const donutChartData = {
    series: DchartData?.map((data) => data.y),
    options: {
      chart: {
        toolbar: {
          show: false,
        },
        type: "donut",
        height: 450,
      },
      colors: [
        "#4E79A7", // Blue
        "#E15759", // Red
        "#76B7B2", // Teal
        "#F28E2B", // Orange
        "#59A14F", // Green
        "#B07AA1", // Purple
        "#EDC948", // Yellow
        "#8C564B", // Brown
        "#17BECF", // Cyan
        "#FF9DA7", // Pink
        "#1F77B4", // Blue
        "#D62728", // Red
        "#9467BD", // Purple
        "#FF7F0E", // Orange
        "#2CA02C", // Green
        "#BCBD22", // Lime
        "#9C755F", // Tan
        "#BAB0AC", // Gray
        "#E377C2", // Magenta
        "#7F7F7F", // Neutral Gray
      ],
      legend: {
        position: "bottom",
        fontWeight: 500,
      },
      labels: DchartData?.map((data) => data?.x),
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
      plotOptions: {
        pie: {
          donut: {
            size: "65%",
            labels: {
              show: true,
              name: {
                show: true,
                fontSize: "22px",
                fontWeight: 600,
                color: "#8b44ff",
                offsetY: -10,
              },
              value: {
                show: true,
                fontSize: "16px",
                fontWeight: 400,
                color: "#8b44ff",
                offsetY: 16,
                formatter: function (val, opts) {
                  return `${val} Visitors`;
                },
              },
              total: {
                show: true,
                label: "Visitors",
                color: "#8b44ff",
                fontSize: "22px",
                fontWeight: 600,
                formatter: function (w) {
                  const total = w.globals.seriesTotals.reduce(
                    (a, b) => a + b,
                    0
                  );
                  return `${total}`;
                },
              },
            },
          },
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (val, opts) {
          const count = opts.w.globals.series[opts.seriesIndex];
          return `${count}`;
        },
      },
      tooltip: {
        shared: true,
        intersect: false,
        y: {
          formatter: function (val) {
            return `${val} Visitors`;
          },
        },
      },
    },
  };
  const showDonutChart = donutChartData?.series.length === 0;
  return (
    <>
      <Base>
        <Box
          sx={{
            height: "calc(100vh - 65px)",
            overflowY: "auto",
            position: "relative",
            pt: 4,
            pb: 3,
            pl: 1,
            pr: 1,
          }}
        >
          <BackdropMeepl open={visitorLoading} dark={false}/> 
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
          >
            <Grid item xs={4} md={3}>
              <Card sx={{ display: "block", overflow: "visible" }}>
                <CardContent sx={{ padding: "12px !important" }}>
                  <Box justifyContent={"space-between"} display="flex">
                    <Typography
                      sx={{ fontSize: 14 }}
                      variant="subtitle2"
                      color="primary.contrastText"
                      gutterBottom
                    >
                      Today's Visitors
                    </Typography>
                  </Box>
                  <Box justifyContent={"space-between"} display="flex">
                    <Typography textAlign="center" variant="h3" gutterBottom>
                      {visitors_dashboard_data?.[0]?.visitor_summary?.[
                        "Today Visitors"
                      ]
                        ? visitors_dashboard_data?.[0]?.visitor_summary?.[
                            "Today Visitors"
                          ]
                        : 0}
                    </Typography>
                    <img
                      src={company_visitor}
                      alt="Ratings"
                      className="card-icon"
                    />
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={4} md={3}>
              <Card sx={{ display: "block", overflow: "visible" }}>
                <CardContent sx={{ padding: "12px !important" }}>
                  <Box justifyContent={"space-between"} display="flex">
                    <Typography
                      sx={{ fontSize: 14 }}
                      variant="subtitle2"
                      color="primary.contrastText"
                      gutterBottom
                    >
                      Not Checked Out
                    </Typography>
                  </Box>
                  <Box justifyContent={"space-between"} display="flex">
                    <Typography textAlign="center" variant="h3" gutterBottom>
                      {visitors_dashboard_data?.[0]?.visitor_summary?.[
                        "Not Checked Out"
                      ]
                        ? visitors_dashboard_data?.[0]?.visitor_summary?.[
                            "Not Checked Out"
                          ]
                        : 0}
                    </Typography>
                    <img
                      src={not_checked_out}
                      alt="Ratings"
                      className="card-icon"
                    />
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={4} md={3}>
              <Card sx={{ display: "block", overflow: "visible" }}>
                <CardContent sx={{ padding: "12px !important" }}>
                  <Box justifyContent={"space-between"} display="flex">
                    <Typography
                      sx={{ fontSize: 14 }}
                      variant="subtitle2"
                      color="primary.contrastText"
                      gutterBottom
                    >
                      Total Visitors
                    </Typography>
                  </Box>
                  <Box justifyContent={"space-between"} display="flex">
                    <Typography textAlign="center" variant="h3" gutterBottom>
                      {visitors_dashboard_data?.[0]?.visitor_summary?.[
                        "Total Visitors"
                      ]
                        ? visitors_dashboard_data?.[0]?.visitor_summary?.[
                            "Total Visitors"
                          ]
                        : 0}
                    </Typography>
                    <img src={visitors} alt="Ratings" className="card-icon" />
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={4} md={3}>
              <Card sx={{ display: "block", overflow: "visible" }}>
                <CardContent sx={{ padding: "8px !important" }}>
                  <FormControl fullWidth>
                    <CommonDatePicker
                      name="from_date"
                      label="From Date"
                      size="small"
                      pickerType="date"
                      onKeyPress={(e) => e.preventDefault()}
                      onKeyDown={(e) => e.preventDefault()}
                      pickerFormat="dd/MM/yyyy"
                      DefaultDTvalue={filters.from_date}
                      maxDate={filters?.to_date ? new Date(filters.to_date) : new Date()}
                      minDate={new Date(minDojYear)} 
                      handleChange={(value) =>
                        handleFilter({
                          target: {
                            name: "from_date",
                            value: value
                              ? `${
                                  value?.getFullYear() +
                                  "-" +
                                  ("0" + (value?.getMonth() + 1))?.slice(-2) +
                                  "-" +
                                  ("0" + value?.getDate())?.slice(-2)
                                }`
                              : "",
                          },
                        })
                      }
                    />
                  </FormControl>
                  <Box mt={1.5}></Box>
                  <FormControl fullWidth>
                    <CommonDatePicker
                      name="to_date"
                      label="To Date"
                      size="small"
                      pickerType="date"
                      onKeyPress={(e) => e.preventDefault()}
                      onKeyDown={(e) => e.preventDefault()}
                      pickerFormat="dd/MM/yyyy"
                      DefaultDTvalue={filters.to_date}
                      maxDate={new Date()}
                      minDate={filters?.from_date ? new Date(filters.from_date) : null}
                      handleChange={(value) =>
                        handleFilter({
                          target: {
                            name: "to_date",
                            value: value
                              ? `${
                                  value?.getFullYear() +
                                  "-" +
                                  ("0" + (value?.getMonth() + 1))?.slice(-2) +
                                  "-" +
                                  ("0" + value?.getDate())?.slice(-2)
                                }`
                              : "",
                          },
                        })
                      }
                    />
                  </FormControl>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          <Grid
            mt={2}
            container
            display="flex"
            direction="row"
            justifyContent="center"
            alignItems="start"
            spacing={1}
          >
            <Grid
              item
              xs={12}
              md={6}
              lg={6}
              sx={{ height: "510px", backgroundColor: "#ffffff" }}
            >
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor: "#ffffff",
                }}
              >
                <CardHeader
                  sx={{ backgroundColor: "#ffffff" }}
                  title={
                    <Typography variant="h6">{"Visitor Statistic"}</Typography>
                  }
                />
                <Box sx={{ flexGrow: 1, backgroundColor: "#ffffff" }}>
                  <VisitorChartWithPagination
                    setCurrentPage={setCurrentPage}
                    currentPage={currentPage}
                    totalPages={totalPages}
                    chartData={chartData}
                    showPagination={true}
                  />
                </Box>
              </Card>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              lg={6}
              sx={{ height: "510px", backgroundColor: "#ffffff" }}
            >
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor: "#ffffff",
                }}
              >
                <CardHeader
                  sx={{ backgroundColor: "#ffffff" }}
                  title={
                    <Typography pb={1} variant="h6">
                      Visitor Types
                    </Typography>
                  }
                />
                <Box sx={{ flexGrow: 1, backgroundColor: "#ffffff" }}>
                  {showDonutChart === true ? (
                    <>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          height: "370px",
                        }}
                      >
                        <Typography
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                        >
                          {" "}
                          No Records{" "}
                        </Typography>
                      </Box>
                    </>
                  ) : (
                    <>
                      <Box
                        className="my-donut-chart"
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          paddingBottom: "5px",
                          backgroundColor: "#ffffff",
                        }}
                      >
                        <Chart
                          options={donutChartData.options}
                          series={donutChartData.series}
                          type="donut"
                          width="380"
                          height="430"
                        />
                      </Box>
                    </>
                  )}
                </Box>
              </Card>
            </Grid>

            { entryGateDataLength > 1 && (<Grid
              item
              xs={12}
              md={12}
              sx={{ height: "510px", backgroundColor: "#ffffff" }}
            >
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor: "#ffffff",
                }}
              >
                <CardHeader
                  sx={{ backgroundColor: "#ffffff" }}
                  title={
                    <Box display="flex" alignItems="center" gap={"15px"}>
                      <Typography variant="h6">Visitors By Access Area</Typography>
                      <Typography variant="body2" color="inherit">
                        {ConvertDate(`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`)}
                      </Typography>
                    </Box>
                  }
                />
                <Box sx={{ flexGrow: 1, backgroundColor: "#ffffff" }}>
                  <VisitorChartWithPagination
                    chartData={chartData2}
                    showPagination={false}
                  />
                </Box>
              </Card>
            </Grid>)}
          </Grid>
        </Box>
      </Base>
    </>
  );
};

export default VisitorsDashboard;
